import * as React from 'react';
import { TileLayout } from '@progress/kendo-react-layout';
import { ExternalSystems } from '../components/esconfig/ExternalSystems' 

export const EST = () => {

    const [data, setData] = React.useState([
        {
            col: 1,
            colSpan: 4,
            rowSpan: 2,
        }
    ]);
    const tiles = [
        {
            header: 'External Systems',
            body: <ExternalSystems />,
        }
    ];
    const handleReposition = (e) => {
        setData(e.value);
    };
    return (
        <TileLayout
            columns={4}
            rowHeight={400}
            positions={data}
            gap={{
                rows: 10,
                columns: 10,
            }}
            items={tiles}
            onReposition={handleReposition}
        />
    );
};